import Menu from 'ui/Menu';

import { useSankeyStateHistoryContext } from '../../../contexts/sankeyStateHistoryContext';
import { undoKeyCommand } from '../../../utils/keyboard';
import TrackedMenuItem from '../TrackedMenuItem';

const UndoMenuItem: React.FC = () => {
  const { canUndo, undo } = useSankeyStateHistoryContext();

  return (
    <TrackedMenuItem value="undo" onClick={undo} disabled={!canUndo}>
      Undo <Menu.ItemCommand>{undoKeyCommand}</Menu.ItemCommand>
    </TrackedMenuItem>
  );
};

export default UndoMenuItem;
